import { skipToken } from '@reduxjs/toolkit/query'
import { useAppSelector } from '../../../store/hooks'
import { selectAccountId } from '../../../store/auth/authSlice'
import { useGetEntityQuery } from '../../../store/integrations/integrations'
import { IntegrationServiceId } from '../../../common/integrations'

export interface ResolvedReferenceLabel {
  label: string | undefined
  isLoading: boolean
}

interface EntityDetail {
  referenceValues?: { label: string; value?: string | null }[]
}

export const useResolvedReferenceLabel = (
  serviceId: IntegrationServiceId,
  referenceObjectName: string | undefined,
  id: string,
  buildEntityRoutingKey: (referenceObjectName: string) => string,
): ResolvedReferenceLabel => {
  const accountId = useAppSelector(selectAccountId)
  const skip = !referenceObjectName || !id
  const { data, isLoading } = useGetEntityQuery(
    skip ? skipToken : { accountId, connector: serviceId, objectName: buildEntityRoutingKey(referenceObjectName), entityId: id },
  )

  const label = (data as EntityDetail | undefined)?.referenceValues?.[0]?.value ?? undefined
  return { label, isLoading }
}
